import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import CH from '../gadgets/cookieHandler';

import envConf from '../../config/env.conf';
const ENV = envConf[process.env.BUILD_MODE];

import axios from 'axios';

const baseURL = '/rfInf/';
const axiosPOSTInstance = axios.create({
  baseURL
});

function _POST ({ dispatch, commit }, url = '', params = {}, option = {}) {
  return axiosPOSTInstance.post(url, params, option).then((res) => {
    if (res.status === 200) {
      return toString.call(res.data) === '[object String]' ? JSON.parse(res.data) : res.data;  // 返回
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    return Promise.reject(res);
  });
}

function POST ({ dispatch, commit }, url = '', params = {}, option) {
  return _POST({ dispatch, commit }, url, params, option).then((res) => {
    if (res.code === '000000') {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    return Promise.reject(res);
  });
}

export default new Vuex.Store({
  state: {
    loginStatus:  false,
    empGuid:      null,
    empInfo:          {},
  },
  mutations:  {   // Commit to change states
    IS_LOGIN (state) {
      state.loginStatus = true;
    },
    NOT_LOGIN (state) {
      state.loginStatus = false;
    },
    HAS_LOGGED_OUT (state) {
      state.loginStatus = null;
    },

    SET_GUID (state, empGuid) {
      state.empGuid = empGuid;
    },
    SET_EMP_INFO (state, emp) {
      state.empInfo = emp;
    }
  },
  actions:  {     // Dispatch to operate actions or commit mutation.
    /**************************
     *  检查 empGuid 是否存在  *
     **************************/
    CHECK_EMP_GUID ({ dispatch, commit, state }) {
      const { content } = new CH('EMPGUID');
      if (content) {
        commit('SET_GUID', content);
        commit('IS_LOGIN');
        return Promise.resolve(content);
      } else {
        commit('NOT_LOGIN');
        return Promise.resolve(null);
      }
    },

    /**********
     *  登录  *
     **********/
    LOGIN ({ dispatch, commit }, { countryCode = null, userName = null, userPwd = null, empGuid = null } = {}) {
      const url = '/adminLogin.shtml';
      const params = { countryCode, userName, userPwd, empGuid };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('IS_LOGIN');

        if (!empGuid) {                // If login with userName and userPwd, mark down the empGuid
          let r = new CH('EMPGUID');
          r.set(data.empGuid + '', 30 * 24 * 60 * 60 * 1000, ENV['domain']);     // 30 days
        }

        commit('SET_EMP_INFO', data);
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    LOGIN_NEW ({ dispatch, commit }, { userName = null, userPwd = null, type = null } = {}) {
      const url = '/adminCheckLogin.shtml';
      const params = { userName, userPwd, type };
      return POST({ dispatch, commit }, url, params);
    },

    /**********
     *  注销  *
     **********/
    LOGOUT ({ dispatch, commit }) {
      CH.remove('EMPGUID', ENV['domain']);
      commit('HAS_LOGGED_OUT');
    },

    /**************
     *  修改密码  *
     **************/
    EDIT_PASSWORD ({ dispatch, commit }, { oldPwd, newPwd, empGuid } = {}) {
      const url = '/empModifyPwd.shtml';
      const params = { oldPwd, newPwd, empGuid };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取用户信息  *
     *****************/
    GET_EMP_INFO ({ dispatch, commit, state }, mobile) {
      const url = '/getEmpInfo.shtml';
      const params = { mobile };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_EMP_INFO', data);
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /*****************
     *  用户能够访问POMP系统列表  *
     *****************/
    GET_POMP_PRIVILEGE_LIST ({ dispatch, commit, state }, params) {
      const url = '/getPOMPPrivilegeList.shtml';
      return POST({ dispatch, commit }, url, params).then((data) => {
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /**************
     *  获取国别号列表  *
     **************/
    GET_PM_COUNTRY_CODES ({ dispatch, commit }, { empGuid } = {}) {
      const url = '/getPmCountryCodes.shtml';
      const params = { empGuid };

      return POST({ dispatch, commit }, url, params);
    },

    /**********
     *  企业微信扫码登录  *
     **********/
    QYWX_LOGIN ({ dispatch, commit }, { code = null } = {}) {
      const url = '/qyWxWebLogin.shtml';
      const params = { code };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('IS_LOGIN');

        let r = new CH('EMPGUID');
        r.set(data.empGuid + '', 30 * 24 * 60 * 60 * 1000, ENV['domain']);     // 30 days

        commit('SET_EMP_INFO', data);
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },
    /**************
     *  获取意见反馈列表  *
     **************/
    GET_COMMENT_LIST ({ dispatch, commit }, params) {
      const url = '/getCommentList.shtml';
      return POST({ dispatch, commit }, url, params);
    },
    GET_COMMENT_DETAIL ({ dispatch, commit }, params) {
      const url = '/getCommentDetail.shtml';
      return POST({ dispatch, commit }, url, params);
    },
    COMMENT_ADD ({ dispatch, commit }, params) {
      const url = '/commentAdd.shtml';
      return POST({ dispatch, commit }, url, params);
    },
    COMMENT_ADDS ({ dispatch, commit }, params) {
      const url = '/commentAdditional.shtml';
      return POST({ dispatch, commit }, url, params);
    },
    COMMENT_ADD_F ({ dispatch, commit }, params) {
      const url = '/commentAddByFile.shtml';
      return POST({ dispatch, commit }, url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    COMMENT_ADDS_F ({ dispatch, commit }, params) {
      const url = '/commentAdditionalByFile.shtml';
      return POST({ dispatch, commit }, url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    COMMENT_FINISH ({ dispatch, commit }, params) {
      const url = '/commentFinish.shtml';
      return POST({ dispatch, commit }, url, params);
    },
    GET_MODULE ({ dispatch, commit }, params) {
      const url = '/getCommentModuleList.shtml';
      return POST({ dispatch, commit }, url, params);
    }
  },
  getters: {      // Get states statically
    isLogin ({loginStatus}) {
      return !!loginStatus;
    },
    GUID ({empGuid}) {
      return empGuid;
    },
    EMP_INFO ({empInfo}) {
      return empInfo;
    }
  }
});



// WEBPACK FOOTER //
// ./src/vuex/index.js